/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.CaseController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { DocumentSoortModel } from '../models/document-soort-model';
import { GetCaseResponse } from '../models/get-case-response';
import { ZaakModel } from '../models/zaak-model';

@Injectable()
export class CaseApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getCases(spinnerMessage: string = null): Observable<GetCaseResponse> {
        return this.httpClient.get<GetCaseResponse>(`/api/case`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getDocumentByDocumentId(documentIdHash: string, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.get<void>(`/api/case/document/${encodeURIComponent(documentIdHash)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getDocumentTypesByCaseId(caseId: number, spinnerMessage: string = null): Observable<DocumentSoortModel[]> {
        return this.httpClient.get<DocumentSoortModel[]>(`/api/case/document/types/${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getCaseInfo(caseId: number, spinnerMessage: string = null): Observable<ZaakModel> {
        return this.httpClient.get<ZaakModel>(`/api/case/caseinfo?caseId=${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }



    public uploadDocuments(formData: FormData, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/case/document/upload`, formData,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }
}
